import { SelectionModel } from "@angular/cdk/collections";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import {
  AfterViewInit,
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatStepper } from "@angular/material/stepper";
import { MatTableDataSource } from "@angular/material/table";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import * as moment from 'moment-timezone';
import { ToastrService } from "ngx-toastr";
import { Observable, map, startWith } from "rxjs";
import { MyErrorStateMatcher } from "src/app/auth/login/login.component";
import { AttributeValues } from "src/app/contract/shared/attribute-values.model";
import { Contract } from "src/app/contract/shared/contract.model";
import { ContractService } from "src/app/contract/shared/contract.service";
import { UserService } from "src/app/shared/user.service";
import { ContractHistoryComponent } from "./enter-validation/contract-history/contract-history.component";
import { RejectDialogComponent } from "../../reject-dialog/reject-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ContractReviewerComponent } from "./enter-validation/contract-reviewer/contract-reviewer.component";
import { ContractApprovalsComponent } from "./enter-validation/contract-approvals/contract-approvals.component";
import { ContractSignatureComponent } from "./contract-signature/contract-signature.component";
import { UserManagementService } from "src/app/contract/shared/user-management.service";
import { AccountService } from "src/app/contract/shared/account.service";
import { Account } from "src/app/contract/shared/account.model";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { AddSignatoryComponent } from "./contract-signature/add-signatory/add-signatory.component";
import { DocuSignService } from "src/app/contract/shared/docusign.service";
import { RecallDialogComponent } from "../../recall-dialog/recall-dialog.component";

@Component({
  selector: "app-contract-form",
  templateUrl: "./contract-form.component.html",
  styleUrls: ["./contract-form.component.scss"],
})
export class ContractFormComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  dataSource = new MatTableDataSource<any>([]);
  obligationSource = new MatTableDataSource<any>([]);
  obligationData: any[] = []; // For PrimeNG table
  @ViewChild('templatePaginator') templatePaginator: MatPaginator;
  @ViewChild('obligationPaginator') obligationPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // PrimeNG table properties
  selectedObligations: any[] = [];
  @ViewChild("stepper") stepper!: MatStepper;
  @ViewChild("contractInput") contractInput!: ElementRef<HTMLInputElement>;
  displayedColumns: string[] = [
    "select",
    "Template Name",
    "Description",
    "Version",
    "Last Updated",
    "Download",
  ];
  obligationColumns: string[] = [
    "select",
    "Sr No.",
    "Section & Title",
    "Obligation Text",
    "Frequency",
    "Obligation Owner",
    "Responsible Person Email / User",
    "Status",
    "Action",
  ];
  @ViewChild("childRef") childComponent!: ContractHistoryComponent;
  @ViewChild("reviewerTab") reviewerComponent!: ContractReviewerComponent;
  @ViewChild("approverTab") approverComponent!: ContractApprovalsComponent;
  @ViewChild("fulfillmentFileInput") fulfillmentFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild("uploadFile") uploadFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild("uploadPDF") uploadPDFInput!: ElementRef<HTMLInputElement>;
  @ViewChild("uploadSignedFile") uploadSignedFileInput!: ElementRef<HTMLInputElement>;
  selection = new SelectionModel<any>(false, []);
  obligationSelection = new SelectionModel<any>(true, []);

  id: number;
  mode: string;
  contractForm: FormGroup;
  dataForm: FormGroup;
  obligationsForm: FormGroup;
  metadataForm: FormGroup = new FormGroup([]);
  templateForm: FormGroup;
  currentStepIndex: number = 0; // Track current step index for button visibility

  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  formLoading: boolean = false;
  filteredOptions: Observable<string[]>;
  downloadLoading: { [key: string]: boolean } = {};
  dataLoading: boolean = false;

  contractTypes: [] = [];
  transactions: [] = [];
  obligationTypes: [] = [];
  accountList: Account[] = [];
  timeLines: [] = [];
  frequencies: [] = [];
  reminderdays: [] = [];
  approvals: [] = [];
  isNotFound: boolean = false;
  contract: Contract = new Contract();
  dataChanged = false;
  step = 0;

  // Fulfillment file properties
  fulfillmentFile: File | null = null;
  fulfillmentFileUploading = false;
  fulfillmentFileDownloading = false;
  obligationsWithFiles: Set<number> = new Set(); // Track which obligations have files
  obligationFileInfo: Map<number, { name: string, type: string }> = new Map(); // Store file info for downloads

  editorConfig: AngularEditorConfig = {
    editable: false,
    showToolbar: false,
    defaultFontSize: "3",
    toolbarHiddenButtons: [["insertImage"]],
  };

  attributesBySection: { [key: string]: any[] } = {};
  sectionNames: string[] = [];
  sequentialSectionNames: string[] = [];
  values: AttributeValues[] = [];
  booleanValues: { [groupName: string]: { [controlName: string]: string } } =
    {};
  userFullName: string;
  tempAttrib: any[] = [];
  templateList: any[] = [];
  selectedTemplateId: number = null;
  contractSummary: any[] = [];
  previewURL: any;
  viewerType: "pdf" | "office" = "office"; // Default viewer type
  contractDetails: any[] = [];
  fileToUpload: File = null;
  selectedTabIndex: number;
  isContractEditPermission: boolean = false;
  viewMode: boolean = false;
  showObligationForm: boolean = false;

  isFormChanged: boolean = false;
  originalContractFormValue: any = null;
  signatureStepSelected: boolean = false;
  sequentialNames: { [key: string]: any[] } = {};
  isCurrentReviewer: boolean = false;
  isCurrentApprover: boolean = false;
  fieldSuggestions: { [key: string]: string[] } = {}; // Track fields with multiple values/suggestions

  // New properties for AI analysis
  selectedFile: File | null = null;
  isAnalyzing: boolean = false;
  currentObligation: any = null;
  aiAnalysisResults: any[] = [];

  responseTime: string = '';
  private dataLoaded = false;
  private lastUpdatedObligationId: number = null;
  private lastUpdatedObligationData: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private contractService: ContractService,
    private accountService: AccountService,
    public userService: UserService,
    public user: UserManagementService,
    private elementRef: ElementRef,
    private docuSignService: DocuSignService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    if (this.userService.loggedinUser.middleName)
      this.userFullName =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.middleName +
        " " +
        this.userService.loggedinUser.lastName;
    else
      this.userFullName =
        this.userService.loggedinUser.firstName +
        " " +
        this.userService.loggedinUser.lastName;
    this.route.params.subscribe((params) => {
      this.id = parseInt(params["id"]);
      this.mode = params["mode"];
    });

    if (this.mode) this.formLoading = true;

    this.contractForm = this.formBuilder.group({
      contractTypeId: [null],
      contractTypeName: ["", [Validators.required]],
      transactionTypeId: ["", [Validators.required]],
      name: ["", [Validators.required]],
      accountId: [null],
    });

    this.templateForm = this.formBuilder.group({
      templateId: [this.selectedTemplateId, [Validators.required]],
    });

    this.obligationsForm = this.formBuilder.group({
      id: [null],
      status: ['Draft'],
      obligationOwner: [''],
      obligationType: [''],
      obligationText: ['', [Validators.required]],
      sectionNumber: [''],
      frequency: [''],
      startDate: [null],
      agreementStartDate: [null],
      endDate: [null],
      agreementEndDate: [null],
      targetDate: [null],
      responsiblePersonEmail: ['', [Validators.required, Validators.email]],
      advanceReminder: [null],
      fulfillmentDescription: [''],
      // Legacy fields for backward compatibility
      // description: [""],
      personEmail: ["", [Validators.required, Validators.email]],
      entitlementApprovalId: [null, [Validators.required]],
      entitlementFrequencyId: [null, [Validators.required]],
      entitlementReminderNoticeId: [null, [Validators.required]],
      entitlementTypeId: [null, [Validators.required]],
      entitlementTimeLineId: [null, [Validators.required]],
      validFromDate: [null],
      validToDate: [null],
    }, { validators: this.dateRangeValidator });

    // Add frequency change listener to handle target date enable/disable
    this.obligationsForm.get('frequency')?.valueChanges.subscribe(frequency => {
      if (frequency !== 'One-time') {
        // Clear target date when frequency is not One-time
        this.obligationsForm.get('targetDate')?.setValue(null);
      }
    });

    // Add listener to sync personEmail with responsiblePersonEmail
    this.obligationsForm.get('responsiblePersonEmail')?.valueChanges.subscribe(email => {
      this.obligationsForm.get('personEmail')?.setValue(email);
    });

    // Add listener to sync agreementStartDate with validFromDate
    this.obligationsForm.get('agreementStartDate')?.valueChanges.subscribe(date => {
      if (date) {
        this.obligationsForm.get('validFromDate')?.setValue(date);
      }
    });

    // Add listener to sync agreementEndDate with validToDate
    this.obligationsForm.get('agreementEndDate')?.valueChanges.subscribe(date => {
      if (date) {
        this.obligationsForm.get('validToDate')?.setValue(date);
      }
    });
  }

  setSelectedId(id: number) {
    this.selectedTemplateId = id;
    this.templateForm.get("templateId").setValue(id);
  }

  reset() {
    this.obligationsForm.reset();
  }

  onRowSelect(id: any) {
    this.selection.toggle(id);
    if (this.selection.isSelected(id)) this.setSelectedId(id);
    else this.setSelectedId(null);
  }


  onObligationSelectionChange(event: any) {
    // Update the obligationSelection to maintain compatibility with existing code
    this.obligationSelection.clear();
    if (event && event.length > 0) {
      event.forEach(obligation => {
        this.obligationSelection.select(obligation);
      });
    }
    // Update selectedObligations to match the event
    this.selectedObligations = event || [];
  }

  clearObligationSelection() {
    this.selectedObligations = [];
    this.obligationSelection.clear();
  }

  formatCurrency(event: any, formControlName: any): void {
    const input = event.target as HTMLInputElement;

    const currencyPattern = /^(\D)\d{0,3}(,\d{3})*(\.\d{0,2})?$/;

    const { symbol, numericValue } = this.extractSymbolAndNumeric(input.value);

    // Format the numeric part with commas
    const formattedValue = this.formatNumericWithCommas(numericValue);

    // Set the formatted value back into the input
    input.value = symbol + formattedValue;

    if (currencyPattern.test(input.value)) {
      formControlName.setErrors(null);
    } else {
      formControlName.setErrors({ incorrect: true });
    }
  }

  extractSymbolAndNumeric(value: string): {
    symbol: string;
    numericValue: string;
  } {
    // Extract the first character as the currency symbol
    const symbol = value.charAt(0).match(/\D/) ? value.charAt(0) : "";

    // Remove non-numeric and non-dot characters
    const numericValue = value.replace(/[^\d.]/g, "");

    return { symbol, numericValue };
  }

  formatNumericWithCommas(value: string): string {
    // Split the value into integer and decimal parts
    const parts = value.split(".");
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Concatenate integer and decimal parts back together
    const formattedValue =
      parts.length === 1 ? integerPart : integerPart + "." + parts[1];

    return formattedValue;
  }

  removeSerial(value: string): string {
    return value.replace(/^\d+\.\s*/, "").trim();
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  scrollToTop() {
    // Access the window object
    const windowRef = this.elementRef.nativeElement.ownerDocument.defaultView;

    // Scroll to the top
    if (windowRef) {
      windowRef.scrollTo({ top: 0, behavior: "smooth" }); // Use 'auto' for instant scroll
    }
  }

  isFormUnchanged(): boolean {
    return (
      JSON.stringify(this.contractForm.value) ===
      JSON.stringify(this.originalContractFormValue)
    );
  }

  // Custom validator for date range validation
  dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {
    const startDate = control.get('agreementStartDate');
    const endDate = control.get('agreementEndDate');

    // Only validate if both dates are provided
    if (startDate && endDate && startDate.value && endDate.value) {
      const start = new Date(startDate.value);
      const end = new Date(endDate.value);

      if (start > end) {
        return { 'dateRangeInvalid': true };
      }
    }

    return null;
  }

  // Helper method to format dates for API (preserves local date without timezone conversion)
  private formatDateForAPI(date: any): string | null {
    if (!date) return null;

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return null;

    // Format as YYYY-MM-DD to avoid timezone issues
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}T00:00:00.000Z`;
  }

  // Helper method to parse dates from API (handles timezone conversion)
  private parseDateFromAPI(dateString: string): Date | null {
    if (!dateString) return null;

    // Parse the date string and create a new date in local timezone
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;

    // Return the date as-is (browser will handle timezone display)
    return date;
  }

  // Helper method to format dates for display
  private formatDateForDisplay(dateString: string): string {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';

    // Format as DD/MM/YYYY for display
    return date.toLocaleDateString('en-GB');
  }

  // Helper method to map advance reminder from API to form value
  private mapAdvanceReminderForForm(apiValue: string | null): string | null {
    if (!apiValue) return null;

    const mapping = {
      'None': null,
      '7 days': '7',
      '15 days': '15',
      '30 days': '30'
    };

    return mapping[apiValue] || null;
  }

  // Helper method to preserve AI description during updates
  private preserveAIDescription(formData: any, currentObligation: any): string {
    // For new obligations, use fulfillmentDescription
    if (!formData.id) {
      return formData.fulfillmentDescription || '';
    }

    // For updates, preserve the original AI description from currentObligation
    if (currentObligation && currentObligation.description && currentObligation.description !== 'NA') {
      return currentObligation.description;
    }

    // Fallback to original obligation data if available
    if (currentObligation && currentObligation.oblText) {
      return currentObligation.oblText;
    }

    // Final fallback
    return formData.fulfillmentDescription || '';
  }

  ngAfterViewInit(): void {
    // Initialize current step index based on stepper's initial selected index
    if (this.stepper) {
      this.currentStepIndex = this.stepper.selectedIndex ?? 0;
    }
    // Connect paginators after view is initialized
    this.connectPaginator();
  }

  ngAfterViewChecked(): void {
    // Reconnect paginator if data has been loaded but paginator is not working
    if (this.dataLoaded && this.templatePaginator && this.dataSource.data.length > 0) {
      if (this.templatePaginator.length === 0) {
        this.dataSource.paginator = this.templatePaginator;
        this.templatePaginator.length = this.dataSource.data.length;
        this.cdr.detectChanges();
      }
    }
  }

  ngOnDestroy(): void {
    // Clean up paginator connection
    if (this.dataSource) {
      this.dataSource.paginator = null;
    }
  }

  private connectPaginator(): void {
    // Connect template table paginator to dataSource
    if (this.templatePaginator) {
      this.dataSource.paginator = this.templatePaginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }

    // Connect obligation table paginator to dataSource
    if (this.obligationPaginator) {
      this.obligationSource.paginator = this.obligationPaginator;
    }
    if (this.sort) {
      this.obligationSource.sort = this.sort;
    }
  }

  async ngOnInit() {
    await this.contractService.getContractTypes().then((res: any) => {
      this.contractTypes = res.filter(contracttype => {
        const permissionKey = `_CONTRACT_${contracttype.name.toUpperCase()}_ADD_`;
        return this.userService.permissionsValue[permissionKey];
      });
      this.contractTypes = res;
    });

    await this.contractService.getTransactionTypes().then((res: any) => {
      this.transactions = res;
    });

    this.contractService.getEntitlementFrequencies().then((res: any) => {
      this.frequencies = res;
    });

    this.contractService.getEntitlementReminderNotices().then((res: any) => {
      this.reminderdays = res;
    });

    // Load active accounts for account selection
    this.loadAccounts();

    this.contractService.getEntitlementTimeLines().then((res: any) => {
      this.timeLines = res;
    });

    this.contractService.getEntitlementType().then((res: any) => {
      this.obligationTypes = res;
    });

    this.contractService.getEntitlementApprovals().then((res: any) => {
      this.approvals = res;
    });

    if (this.mode && this.id) {
      await this.contractService
        .refreshContract(this.id)
        .then((res: Contract) => {
          this.contract = res;
          this.contractForm.patchValue(this.contract);
          if (this.contract.templateId) {
            this.setSelectedId(this.contract.templateId);
            this.onRowSelect(this.contract.templateId);
          }
        });

      this.originalContractFormValue = this.contractForm.value;

      this.initializeMetaForm();
      this.initializeTemplate();
      this.initializeValidation();
      this.getObligations();
      this.isReviewer();
      this.isApprover();

      this.contractForm.get("transactionTypeId").disable();
    }

    this.contractForm.valueChanges.subscribe(() => {
      this.isFormChanged = !this.isFormUnchanged();
    });

    if (this.contractTypes) {
      this.filteredOptions = this.contractForm
        .get("contractTypeName")
        .valueChanges.pipe(
          startWith(""),
          map((value) => this._filter((value as string) || ""))
        );
    }

    if (this.mode == "view") {
      this.contractForm.disable();
      this.metadataForm.disable();
      this.templateForm.disable();
      this.obligationsForm.disable();
    }
  }

  onContractTypeSelect(event) {
    this.contractForm
      .get("contractTypeId")
      .setValue(event.option.value.contractTypeId);
    this.contractForm.get("contractTypeName").setValue(event.option.value.name);

    if (this.contractTypes) {
      this.filteredOptions = this.contractForm
        .get("contractTypeName")
        .valueChanges.pipe(
          startWith(""),
          map((value) => this._filter((value as string) || ""))
        );
    }
  }
  async getContract() {
    try {
      const res = await this.contractService.refreshContract(this.id) as Contract;
      this.contract = res;

      // Check if this is a fallback contract due to parsing error
      if (res.name === 'Contract (Data Error)') {
        this.toast.warning('Contract data could not be fully loaded due to a backend issue. Some features may be limited.', 'Data Loading Issue');
        this.showDataErrorNotification();
      }
    } catch (error) {
      console.error('Error loading contract:', error);
      this.toast.error('Failed to load contract data. Please try again or contact support if the issue persists.', 'Error');
    }

    this.isReviewer();
    this.isApprover();
  }

  private showDataErrorNotification() {
    // Show a more detailed notification about the data error
    const notification = this.toast.info(
      'The contract data contains circular references that prevent proper loading. This is a backend issue that needs to be fixed by the development team.',
      'Technical Issue',
      {
        timeOut: 10000,
        closeButton: true,
        enableHtml: true
      }
    );
  }

  private _filter(value: string): any[] {
    this.isNotFound = false;
    const filterValue = value?.toLowerCase();
    const results = this.contractTypes.filter((option: any) =>
      option.name?.toLowerCase().includes(filterValue)
    );
    if (results.length === 0) this.isNotFound = true;

    return results;
  }

  onInputChange(value: string) {
    this.filteredOptions = this.contractForm
      .get("contractTypeName")
      .valueChanges.pipe(
        startWith(value),
        map((val) => this._filter((val as string) || ""))
      );
  }

  loadAccounts() {
    // Load only active accounts
    this.accountService.getAccounts({
      pageNo: 0,
      pageSize: 1000,
      sortBy: 'name',
      sortDir: 'ASC',
      status: 'ACTIVE',
      tenantId: this.userService.loggedinUser?.tenantId?.toString() || '1'
    }).subscribe({
      next: (response) => {
        this.accountList = response.content || [];
      },
      error: (error) => {
        console.error('Error loading accounts:', error);
        this.toast.error('Failed to load accounts', 'Error');
      }
    });
  }

  onTabClick(event: MatTabChangeEvent) {
    const selectedIndex = event.index;
    this.selectedTabIndex = event.index;
    
    // Check if History tab is clicked (index 5 or 6 depending on isMandatoryFilled)
    const historyTabIndex = this.contract?.isMandatoryFilled ? 6 : 5;
    
    if ([4, 5, 6].includes(selectedIndex)) {
      this.getObligations();
      // Only call ngOnInit if it's not the History tab (History tab will be handled separately)
      if (selectedIndex !== historyTabIndex && this.childComponent) {
        this.childComponent.ngOnInit();
      }
    }
    
    // Handle History tab refresh
    if (selectedIndex === historyTabIndex) {
      // Force change detection to ensure the component is rendered (due to *ngIf)
      this.cdr.detectChanges();
      
      // Use a retry mechanism to ensure the component is available
      let retryCount = 0;
      const maxRetries = 20;
      const checkAndRefresh = () => {
        if (this.childComponent) {
          // Component exists, refresh the history
          this.childComponent.refreshHistory();
        } else if (retryCount < maxRetries) {
          // Component not yet available, retry after a short delay
          retryCount++;
          this.cdr.detectChanges();
          setTimeout(checkAndRefresh, 100);
        }
      };
      // Start checking after a short delay to allow Angular to render
      setTimeout(checkAndRefresh, 100);
    }
  }
  onTeamsTabClick(event: MatTabChangeEvent) {
    if (event.index == 0) {
      this.reviewerComponent.ngOnInit();
    } else {
      this.approverComponent.ngOnInit();
    }
  }

  selectionChange(event: StepperSelectionEvent) {
    // Update current step index for button visibility
    this.currentStepIndex = event.selectedIndex;

    // Prevent navigation to future steps if current step is not valid
    if (this.mode != 'view' && event.previouslySelectedIndex !== undefined) {
      const previousIndex = event.previouslySelectedIndex;
      const newIndex = event.selectedIndex;

      // Only validate when moving forward
      if (newIndex > previousIndex) {
        // Determine which steps are reviewer/approval steps (skippable)
        const hasTemplateStep = this.contract?.transactionTypeId == 1;
        const reviewerStepIndex = hasTemplateStep ? 4 : 3;
        const approvalStepIndex = hasTemplateStep ? 5 : 4;

        // Validate all previous steps before allowing navigation (skip reviewer/approval steps)
        for (let i = 0; i < newIndex; i++) {
          // Skip validation for reviewer and approval steps
          if (i === reviewerStepIndex || i === approvalStepIndex) {
            continue;
          }

          if (!this.isStepValid(i)) {
            // Prevent navigation by resetting to previous step
            setTimeout(() => {
              if (this.stepper) {
                this.stepper.selectedIndex = previousIndex;
              }
            }, 0);
            this.toast.warning('Please complete all previous steps before proceeding.', '');
            return;
          }
        }
      }
    }

    this.selectedTabIndex = event.selectedIndex;
    if (event.selectedIndex === 6 || event.selectedIndex === 5) {
      this.signatureStepSelected = true;
    } else {
      this.signatureStepSelected = false;
    }

    if ([2, 3].includes(event.selectedIndex)) {
      this.initializeValidation();
      // If navigating to Validation step and document exists, refresh preview URL
      if (event.selectedIndex === 3 && this.contract?.isMandatoryFilled && this.contract?.templateId) {
        // Force refresh of preview URL by clearing and reloading
        this.previewURL = null;
        this.contractService
          .downloadDocument(this.id)
          .subscribe((response: any) => {
            this.viewerType = this.getViewerType(response);
            this.previewURL = response;
          });
      }
    }

    // Refresh reviewer and approver components when navigating to their steps
    // Determine step indices based on whether template step exists
    const hasTemplateStep = this.contract?.transactionTypeId == 1;
    const reviewerStepIndex = hasTemplateStep ? 4 : 3;
    const approverStepIndex = hasTemplateStep ? 5 : 4;

    if (event.selectedIndex === reviewerStepIndex) {
      // Refresh contract data first, then refresh reviewer component
      this.getContract().then(() => {
        this.reviewerComponent?.refreshReviewer();
      });
    } else if (event.selectedIndex === approverStepIndex) {
      // Refresh contract data first, then refresh approver component
      this.getContract().then(() => {
        this.approverComponent?.refreshApprover();
      });
    } else {
      // For other steps, just refresh without waiting
      this.reviewerComponent?.refreshReviewer();
      this.approverComponent?.refreshApprover();
    }
  }

  isValidationStep(): boolean {
    // Validation step is at index 3 if template step exists (transactionTypeId == 1)
    // Validation step is at index 2 if template step doesn't exist (transactionTypeId != 1)
    if (this.contract?.transactionTypeId == 1) {
      return this.currentStepIndex === 3;
    } else {
      return this.currentStepIndex === 2;
    }
  }

  isStepValid(stepIndex: number): boolean {
    switch (stepIndex) {
      case 0: // Contract Info
        return this.contractForm && this.contractForm.valid;
      case 1: // Enter Data
        return this.metadataForm && this.metadataForm.valid && this.values.length > 0;
      case 2: // Select Template (only if transactionTypeId == 1) or Validation (if no template step)
        if (this.contract?.transactionTypeId == 1) {
          // Template step exists - validate template selection
          return this.templateForm && this.templateForm.valid && this.selectedTemplateId != null;
        } else {
          // Template step doesn't exist - this is the Validation step
          // Validation step is valid if Enter Data step is completed
          return this.metadataForm && this.metadataForm.valid && this.values.length > 0;
        }
      case 3: // Validation (if template step exists) or Reviewer (if no template step)
        if (this.contract?.transactionTypeId == 1) {
          // Template step exists - this is Validation step
          // Validation step is valid if Template step is completed
          return this.templateForm && this.templateForm.valid && this.selectedTemplateId != null;
        } else {
          // Template step doesn't exist - this is Reviewer step
          // Reviewer step is skippable - always return true
          return true;
        }
      case 4: // Reviewer (if template exists) or Approvals (if no template)
        if (this.contract?.transactionTypeId == 1) {
          // Reviewer step is skippable - always return true
          return true;
        } else {
          // Approvals step is skippable - always return true
          return true;
        }
      case 5: // Approvals (if template exists) or Signatures (if no template)
        if (this.contract?.transactionTypeId == 1) {
          // Approvals step is skippable - always return true
          return true;
        } else {
          // Signatures step is valid if Approvals step is completed
          return [3, 5, 6].includes(this.contract?.statusId);
        }
      case 6: // Signatures (only if template step exists)
        // Signatures step is valid if Approvals step is completed
        return [3, 5, 6].includes(this.contract?.statusId);
      default:
        return true;
    }
  }

  async initializeTemplate() {
    this.dataLoading = true;
    this.dataSource.data = [];
    if (this.contract.transactionTypeId == 1) {
      try {
        await this.contractService
          .getTemplates(this.contract.contractTypeId)
          .then((res: any) => {
            this.templateList = res;
            this.templateList.forEach((template: any) => {
              template.updatedDate = moment(template.updatedDate).format("lll");
            });

            // Sort templates by updatedDate in descending order (latest first)
            this.templateList.sort((a: any, b: any) => {
              const dateA = new Date(a.updatedDate);
              const dateB = new Date(b.updatedDate);
              return dateB.getTime() - dateA.getTime();
            });

            this.dataSource.data = this.templateList;
            this.dataLoaded = true;

            // Force dataSource to update its internal state
            this.dataSource._updateChangeSubscription();

            // Force paginator connection with timeout to ensure view is rendered
            setTimeout(() => {
              // Disconnect and reconnect paginator
              this.dataSource.paginator = null;
              this.cdr.detectChanges();

              setTimeout(() => {
                this.dataSource.paginator = this.templatePaginator;

                // Force paginator to refresh its length
                if (this.templatePaginator) {
                  this.templatePaginator.length = this.dataSource.data.length;
                  this.templatePaginator._changePageSize(this.templatePaginator.pageSize);
                }

                this.cdr.detectChanges();
              }, 100);
            }, 200);
          });
      } catch (error) {
        this.toast.error("Failed to load templates. Please try again later.", "");
      }
    } else {
      // For non-template contracts, ensure paginator is still connected
      setTimeout(() => {
        this.connectPaginator();
      }, 100);
    }
    this.dataLoading = false;
  }

  async getObligations() {
    this.dataLoading = true;

    // Initialize with empty array
    this.obligationData = [];


    try {
      await this.contractService
        .getContractEntitlement(this.id)
        .then((res: any) => {

          // Check if res is an array and has data
          if (!Array.isArray(res) || res.length === 0) {
            this.obligationData = [];
            this.obligationSource.data = [];
            this.dataLoading = false;
            return;
          }

          // Status reverse mapping for display
          const statusReverseMapping = {
            0: 'Draft',
            1: 'Active',
            2: 'Overdue',
            3: 'Fulfilled',
            4: 'Cancelled'
          };

          // Advance reminder reverse mapping for display
          const advanceReminderReverseMapping = {
            0: null,
            1: '7',
            2: '15',
            3: '30',
            'None': null,
            '7 days': '7',
            '15 days': '15',
            '30 days': '30'
          };

          // Map the response data to match the table display format

          // Check if the updated obligation exists in the response
          const updatedObligationId = this.lastUpdatedObligationId;
          if (updatedObligationId) {
            const updatedObligation = res.find(o => o.id === updatedObligationId);
            if (updatedObligation) {
              // Replace the existing obligation with the updated one
              if (this.lastUpdatedObligationData) {
                console.log('Replacing obligation with updated data:', this.lastUpdatedObligationData.validFromDate, this.lastUpdatedObligationData.validToDate);
                const index = res.findIndex(o => o.id === updatedObligationId);
                res[index] = this.lastUpdatedObligationData;
              }
            } else {
              // Workaround: Add the updated obligation to the response
              if (this.lastUpdatedObligationData) {
                console.log('Adding updated obligation to response:', this.lastUpdatedObligationData.validFromDate, this.lastUpdatedObligationData.validToDate);
                res.unshift(this.lastUpdatedObligationData);
              }
            }
          }
          const mappedObligations = res.map((obligation: any, index: number) => {

            // Use the new obligation field names from the API response
            const sectionNumber = obligation.oblSection || 'N/A';
            // const sectionTitle = obligation.oblSection || 'N/A'; // Using oblSection as title
            const obligationText = obligation.oblText || 'No obligation text available';
            const obligationType = obligation.entitlementType || 'N/A';
            const obligationOwner = obligation.oblOwner || 'N/A';
            const frequency = obligation.entitlementFrequency || 'N/A';
            const status = obligation.status !== null && obligation.status !== undefined ? statusReverseMapping[obligation.status] || 'Draft' : 'Draft';
            const responsiblePerson = obligation.personEmail || 'N/A';
            const description = obligation.description || '';
            const advanceReminder = obligation.advanceReminder || 'None';


            const mapped = {
              // Display fields (for backward compatibility)
              'Sr No.': index + 1,
              'Section Number': sectionNumber,
              // 'Section Title': sectionTitle,
              'Obligation Text': obligationText,
              'Obligation Type': obligationType,
              'Owned By': obligationOwner,
              'Frequency': frequency,
              'Status': status,
              'Start Date': this.formatDateForDisplay(obligation.validFromDate),
              'End Date': this.formatDateForDisplay(obligation.validToDate),
              'Responsible Person': responsiblePerson,
              'Advance Reminder': advanceReminder,
              'fulfillmentDescription': obligation.fulfilmentDescription || obligation.fulfillmentDescription || '',
              // Sorting fields (camelCase for PrimeNG sorting) - these are the primary fields
              srNo: index + 1,
              sectionTitle: sectionNumber,
              obligationText: obligationText,
              frequency: frequency,
              obligationOwner: obligationOwner,
              responsiblePerson: responsiblePerson,
              status: status,
              // Additional sorting fields for better sorting
              sectionNumber: sectionNumber,
              // sectionTitleOnly: sectionTitle,
              obligationType: obligationType,
              ownedBy: obligationOwner,
              advanceReminder: advanceReminder,
              startDate: 'N/A',
              endDate: 'N/A',
              // Keep original data for editing
              ...obligation
            };

            return mapped;
          });

          // Sort obligations by creation date (newest first)
          const sortedObligations = mappedObligations.sort((a, b) => {
            const dateA = new Date(a.createDate || a.updateDate || 0);
            const dateB = new Date(b.createDate || b.updateDate || 0);
            return dateB.getTime() - dateA.getTime(); // Newest first
          });

          // Update Sr No. after sorting
          sortedObligations.forEach((obligation, index) => {
            obligation['Sr No.'] = index + 1;
            obligation.srNo = index + 1;
          });

          this.obligationData = sortedObligations;
          // Also update the MatTableDataSource for compatibility
          this.obligationSource.data = sortedObligations;
          // Clear selection when data changes
          this.obligationSelection.clear();

          // Check file existence for first few obligations to show download buttons
          this.checkFilesForVisibleObligations();

          this.dataLoading = false;

        });
    } catch (error) {
      this.toast.error("Something went wrong! Please try again later.", "");
      this.dataLoading = false;

      // Set empty data on error
      this.obligationData = [];
      this.obligationSource.data = [];
    }
  }

  async editObligation(data, view = false) {
    this.obligationsForm.patchValue(data);
    if (data.validFromDate)
      this.obligationsForm
        .get("validFromDate")
        .setValue(new Date(data.validFromDate));

    if (data.validToDate)
      this.obligationsForm
        .get("validToDate")
        .setValue(new Date(data.validToDate));

    if (view) {
      this.obligationsForm.disable();
      this.viewMode = true;
    } else {
      this.obligationsForm.enable();
      this.viewMode = false;
    }
    this.scrollToTop();
  }

  downloadTemplate(templateId) {
    this.downloadLoading[templateId] = true;
    this.contractService.downloadTemplate(templateId);

    setTimeout(() => {
      this.downloadLoading[templateId] = false;
      this.toast.success("Template Downloaded Sucessfully!", "");
    }, 2000);
  }

  // async uploadDocument(files: NgxFileDropEntry[]) {
  //   this.isLoading = true;
  //   for (const droppedFile of files) {
  //     if (droppedFile.fileEntry.isFile) {
  //       const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
  //       fileEntry.file(async (file: File) => {
  //         try {
  //           await this.contractService.uploadThirdPartyTemplate(file, this.id).then(() => {
  //             this.contract.isMandatoryFilled = true;
  //             this.contractService.updateContract(this.contract, this.id).then((res: Contract) => {
  //               this.contract = res;
  //               this.generateDoc();
  //               this.isLoading = false;
  //               this.stepper.next();
  //               this.initializeValidation();
  //             });
  //           });
  //         } catch (error) {
  //           this.toast.error('Something went wrong! Please try again later.', '');
  //         }
  //         this.isLoading = false;
  //       });
  //     }
  //   }
  // }

  getViewerType(url: string): "pdf" | "office" {
    const match = url.match(/\.([a-zA-Z0-9]+)(?=\?|$)/);
    const extension = match ? match[1].toLowerCase() : "";
    // const extension = url.split('.').pop()?.split('?')[0]?.toLowerCase(); // Extract file extension
    return extension === "pdf" ? "pdf" : "office"; // Use 'office' for docx and other office files
  }

  async initializeValidation() {
    this.isContractEditPermission =
      this.userService.permissionsValue[
      "_CONTRACT_" + this.contract.contractTypeName?.toUpperCase() + "_EDIT_"
      ];
    await this.contractService
      .getContractSummaryAttribute(this.id)
      .then((res: any) => {
        this.contractSummary = res;
      });
    if (this.contract.isMandatoryFilled) {
      this.contractService
        .downloadDocument(this.id)
        .subscribe((response: any) => {
          this.viewerType = this.getViewerType(response);
          this.previewURL = response;
        });
    }

    await this.contractService
      .getContractDetailsAttribute(this.id)
      .then((res: any) => {
        this.contractDetails = [...this.contractSummary, ...res];
      });
  }

  downloadDoc(): void {
    this.isLoading = true;
    this.contractService.downloadPDF(this.id);
    setTimeout(() => {
      this.isLoading = false;
      this.toast.success("Contract Downloaded Sucessfully!", "");
    }, 2000);
  }

  async generateDoc() {
    this.isLoading = true;
    try {
      await this.contractService.generateDoc(this.id).then(() => { });
      await this.contractService
        .refreshContract(this.id)
        .then((res: Contract) => {
          this.contract = res;
        });
      this.contract.isMandatoryFilled = true;
      this.contract.isGenerated = true;
      await this.contractService
        .updateContract(this.contract, this.id)
        .then((res: Contract) => {
          this.contract = res;
          this.initializeValidation();
        });
    } catch (error) {
      this.toast.error("Something went wrong! Please try again later.", "");
    }
    this.isLoading = false;
  }

  async handlePDFUpload(files: FileList) {
    this.isLoading = true;
    this.fileToUpload = files.item(0);
    // Include metaDataValues in the field objects to pass dropdown options
    let fieldObjects = this.tempAttrib.map((item) => ({
      label: item.label,
      metaDataTypeId: item.metaDataTypeId,
      metaDataValues: item.metaDataValues // Add this to pass dropdown values
    }));

    // Map MIME type to "pdf" or "docx"
    const mimeType = this.fileToUpload.type;
    const fileType = mimeType === "application/pdf" ? "pdf" : "docx";

    try {
      await this.contractService
        .uploadPDF(this.fileToUpload, fieldObjects, fileType)
        .then((res) => {
          this.handleFileInput(files);

          // Store response time if available - cast to string to fix TypeScript error
          if (res && typeof res === 'object') {
            // Check if response has the Response time property
            const responseObj = res as Record<string, any>;
            if ('Response time' in responseObj) {
              this.responseTime = parseFloat(responseObj['Response time']).toFixed(2);
            }
          }

          // Clear previous suggestions
          this.fieldSuggestions = {};
          // Loop through all section names
          for (const sectionName of this.sectionNames) {
            const sectionGroup = this.metadataForm.get(
              sectionName
            ) as FormGroup;

            if (!sectionGroup) continue;

            const patchData: { [key: string]: any } = {};

            // Loop through each attribute in that section
            for (const attr of this.attributesBySection[sectionName]) {
              const label = attr.label;

              if (res[label] !== undefined) {
                let value = res[label];

                // Handle arrays - store multiple values in our suggestions map
                if (Array.isArray(value) && value.length > 0) {
                  // If only one value in array, just use it directly
                  if (value.length === 1) {
                    patchData[label] = value[0];
                  } else {
                    // Store multiple values for chips
                    this.fieldSuggestions[label] = value;
                    // Don't automatically set a value
                  }
                } else {
                  // Handle single values
                  // Handle checkboxes or custom types
                  if (attr.metaDataTypeId === 12) {
                    value = value == this.getMetaDataValues(attr.metaDataValues, 0) ? false : true;
                  }

                  if (attr.metaDataTypeId === 15 && typeof value === 'string') {
                    value = value.split(/\s*,\s*/);
                  }

                  if (attr.metaDataTypeId === 9 && value) {
                    const date = moment.tz(value, "DD-MM-YYYY", "Asia/Kolkata");
                    if (date.isValid()) {
                      const dateValue = date.toDate();
                      // Check if date is epoch (1/1/1970) and set to null
                      if (dateValue.getTime() === 0 ||
                        (dateValue.getFullYear() === 1970 && dateValue.getMonth() === 0 && dateValue.getDate() === 1)) {
                        value = null;
                      } else {
                        value = dateValue;
                      }
                    } else {
                      value = null;
                    }
                  }

                  patchData[label] = value;
                }
              }
            }

            // Patch only if there's something to patch
            if (Object.keys(patchData).length > 0) {
              sectionGroup.patchValue(patchData);
            }
          }
          // Success message will be shown by handleFileInput method
        });
    } catch (error) {
      this.toast.error("Something went wrong! Please try again later.", "");
    } finally {
      this.isLoading = false;
      this.fileToUpload = null;
      // Reset the file input to allow selecting the same file again
      this.resetFileInput('uploadPDF');
    }
  }

  async handleFileInput(files: FileList) {

    this.isLoading = true;
    this.fileToUpload = files.item(0);

    const mimeType = this.fileToUpload.type;
    const fileType = mimeType === "application/pdf" ? true : false;
    try {
      await this.contractService
        .uploadThirdPartyTemplate(this.fileToUpload, this.id, fileType)
        .then(() => {
          // Show success message immediately after upload
          this.toast.success("Contract Uploaded Successfully!", "");
        });
      await this.contractService
        .refreshContract(this.id)
        .then((res: Contract) => {
          this.contract = res;
          // Don't refresh history immediately - wait for backend processing
        });
      setTimeout(() => {
        this.contract.isMandatoryFilled = true;
        this.contract.isGenerated = true;
        this.contractService
          .updateContract(this.contract, this.id)
          .then((res: Contract) => {
            this.contract = res;
            this.initializeValidation();
            // Refresh history after backend processing is complete
            if (this.childComponent) {
              this.childComponent.refreshHistory();
            }
            // Background processing complete - no additional message needed
          });
      }, 3000);
    } catch (error) {
      this.toast.error("Something went wrong! Please try again later.", "");
    } finally {
      this.isLoading = false;
      this.fileToUpload = null;
      // Reset the file input to allow selecting the same file again
      this.resetFileInput('uploadFile');
    }
  }

  async handleSignedFileInput(files: FileList) {
    this.isLoading = true;
    this.fileToUpload = files.item(0);
    try {
      await this.contractService
        .uploadSignedContract(this.fileToUpload, this.id)
        .then(() => {
          this.toast.success("Signed Contract Uploaded Sucessfully!", "");
        });
      await this.contractService
        .refreshContract(this.id)
        .then((res: Contract) => {
          this.contract = res;
          // Refresh history after signed contract upload
          if (this.childComponent) {
            this.childComponent.refreshHistory();
          }
        });
    } catch (error) {
      this.toast.error("Something went wrong! Please try again later.", "");
    } finally {
      this.isLoading = false;
      this.fileToUpload = null;
      // Reset the file input to allow selecting the same file again
      this.resetFileInput('uploadSignedFile');
    }
  }

  openSignConfirmation(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      enterAnimationDuration: "400ms",
      exitAnimationDuration: "500ms",
      data: {
        title: 'Mark Contract as Signed',
        message: `Are you sure you want to mark the contract "${this.contract.name}" as signed?`,
        confirmText: 'Yes, Mark as Signed',
        cancelText: 'Cancel',
        confirmButtonColor: 'primary',
        confirmFunction: () => this.markAsSigned(dialogRef),
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getContract(); // Refresh contract data after dialog closes
      }
    });
  }

  async markAsSigned(dialogRef: MatDialogRef<ConfirmDialogComponent>) {
    this.isLoading = true;
    try {
      await this.contractService.updateContractStatus(this.id, 6, this.userService?.loggedinUser?.id, null);
      this.toast.success('Contract has been marked as signed successfully!', '');
      await this.getContract();
      dialogRef.close(true);
    } catch (error) {
      this.toast.error(error?.error?.message || 'Failed to mark contract as signed. Please try again.', '');
      dialogRef.close(false);
    } finally {
      this.isLoading = false;
    }
  }

  async openRejectDialog(tileId) {
    const dialogRef = this.dialog.open(RejectDialogComponent, {
      enterAnimationDuration: "400ms",
      exitAnimationDuration: "500ms",
      width: "40%",
      disableClose: true,
      data: {
        contractName: this.contract.name,
        contractId: this.id,
        tileId,
        initialize: () => {
          this.reviewerComponent?.refreshReviewer(),
            this.approverComponent?.refreshApprover();
        },
      },
    });
  }

  async approveOrReview(tileId) {
    this.isLoading = true;
    try {
      if (tileId == 3) {
        await this.contractService.approveContract(this.id).then((res) => {
          this.toast.success("Contract Approved Successfully!", "");
          this.approverComponent?.refreshApprover();
          this.isApprover();
        });
      } else {
        await this.contractService.reviewContract(this.id).then((res) => {
          this.toast.success("Contract Reviewed Successfully!", "");
          this.reviewerComponent?.refreshReviewer();
          this.isReviewer();
        });
      }
      this.isLoading = false;
    } catch (error) {
      console.error(tileId == 3 ? "Approve failed" : "Complete review failed", error);
      this.toast.error(
        this.contractService.describeError(error) ||
        "Something went wrong, Please try again later!",
        tileId == 3 ? "Approval failed" : "Review failed"
      );
      this.isLoading = false;
    }
  }

  async bypassApproval() {
    this.isLoading = true;
    try {
      await this.contractService
        .updateContractStatus(
          this.id,
          3,
          this.userService?.loggedinUser?.id,
          null
        )
        .then(() => {
          this.toast.success("Contract Approval Bypassed Successfully!", "");
        });
      await this.contractService
        .refreshContract(this.id)
        .then((res: Contract) => {
          this.contract = res;
        });
      this.reviewerComponent?.refreshReviewer();
      this.approverComponent?.refreshApprover();
      
      // Force refresh preview URL to show PDF immediately
      if (this.contract?.isMandatoryFilled) {
        // Clear current preview URL to force refresh
        this.previewURL = null;
        // Add a small delay to ensure backend has processed the status change
        setTimeout(() => {
          this.contractService
            .downloadDocument(this.id)
            .subscribe((response: any) => {
              this.viewerType = this.getViewerType(response);
              this.previewURL = response;
              // Force change detection to update the viewer
              this.cdr.detectChanges();
            });
        }, 500);
      }
    } catch {
      this.toast.error("Something went wrong, Please try again later!", "");
    }
    this.isLoading = false;
  }

  async isReviewer() {
    this.isCurrentReviewer = false;
    try {
      // Let the backend decide whose turn it is instead of recomputing the
      // reviewer order here, the same way isApprover() does.
      await this.userService
        .getAllContractsForReviewByLoggedInUser()
        .then((res: any) => {
          (res || []).forEach((item: any) => {
            if (item.contractId == this.id) this.isCurrentReviewer = true;
          });
        });
    } catch {
      this.toast.error("Something went wrong, Please try again later!", "");
    }
  }

  async isApprover() {
    this.isCurrentApprover = false;
    try {
      this.userService
        .getAllContractsForApprovalByLoggedInUser()
        .then((res: any) => {
          res.forEach((item) => {
            if (item.contractId == this.id) this.isCurrentApprover = true;
          });
        });
    } catch {
      this.toast.error("Something went wrong, Please try again later!", "");
    }
  }

  async initializeMetaForm() {
    this.contractForm.get("contractTypeName").disable();
    await this.contractService
      .getContractTypeValues(this.id)
      .then((r: AttributeValues[]) => {
        this.values = r;
      });

    await this.contractService
      .getFullContractType(this.contract?.contractTypeId)
      .then((res: any) => {
        this.tempAttrib = res.attributes;
        this.processContractTypeData(res.attributes);
      });
  }

  formatDate(value: string): string {
    return moment(value).isValid()
      ? moment(value).format("Do MMMM YYYY")
      : value;
  }

  processContractTypeData(attributes: any[]) {
    attributes.forEach((attr) => {
      if (
        !this.attributesBySection[
        attr.sectionName.replace(/^\d+\.\s*/, "").trim()
        ]
      ) {
        this.attributesBySection[
          attr.sectionName.replace(/^\d+\.\s*/, "").trim()
        ] = [];
        this.sequentialNames[attr.sectionName] = [];
      }
      this.attributesBySection[
        attr.sectionName.replace(/^\d+\.\s*/, "").trim()
      ].push(attr);
      this.sequentialNames[attr.sectionName].push(attr);
    });

    this.sectionNames = Object.keys(this.attributesBySection).sort((a, b) => {
      return (
        this.attributesBySection[a][0].sequenceNo -
        this.attributesBySection[b][0].sequenceNo
      );
    });

    this.sequentialSectionNames = Object.keys(this.sequentialNames).sort(
      (a, b) => {
        return (
          this.sequentialNames[a][0].sequenceNo -
          this.sequentialNames[b][0].sequenceNo
        );
      }
    );

    const formGroups: { [key: string]: FormGroup } = {};
    this.sectionNames.forEach((sectionName) => {
      const sectionAttrs = this.attributesBySection[sectionName];
      const group: { [key: string]: any } = {};

      sectionAttrs.forEach((attr) => {
        const controlName = attr.label.toString();
        const attribute: AttributeValues = this.values.find(
          (o) => o.attributeId == attr.attributeId
        );
        let defaultValue =
          this.id && this.values.length > 0
            ? attribute
              ? attribute.attributeValue
              : null
            : attr.defaultValue;

        if (attr.metaDataTypeId == 12) {
          defaultValue =
            defaultValue == this.getMetaDataValues(attr.metaDataValues, 0)
              ? false
              : true;
          this.updateBooleanFormControlValue(
            sectionName,
            controlName,
            defaultValue,
            attr.metaDataValues
          );
        }

        if (attr.metaDataTypeId == 15) {
          defaultValue = defaultValue.split(/\s*,\s*/);
        }

        if (attr.metaDataTypeId == 9) {
          // Handle date fields: if defaultValue is empty, null, undefined, or invalid, set to null
          if (!defaultValue || defaultValue === '' || defaultValue === 'null' || defaultValue === 'undefined') {
            defaultValue = null;
          } else {
            const dateValue = new Date(defaultValue);
            // Check if date is invalid or epoch date (1/1/1970)
            if (isNaN(dateValue.getTime()) || dateValue.getTime() === 0 ||
              (dateValue.getFullYear() === 1970 && dateValue.getMonth() === 0 && dateValue.getDate() === 1)) {
              defaultValue = null;
            } else {
              defaultValue = dateValue;
            }
          }
        }

        if (attr.metaDataTypeId == 5 && attr.isEditable) {
          this.editorConfig.editable = true;
          this.editorConfig.showToolbar = true;
        }

        group[controlName] = [
          { value: defaultValue || null, disabled: !attr.isEditable },
          attr.isRequired ? Validators.required : null,
        ];
      });

      formGroups[sectionName] = this.formBuilder.group(group);
    });

    this.metadataForm = this.formBuilder.group(formGroups);

    // for (const section in this.attributesBySection) {
    //   this.attributesBySection[section].sort((a, b) => {
    //     return a['sequenceNo'] - b['sequenceNo'];
    //   });
    // }

    if (this.mode == "view") this.metadataForm.disable();

    this.formLoading = false;
  }

  hasSectionContent(sectionName: string): boolean {
    if (!this.attributesBySection[sectionName]) {
      return false;
    }
    return this.attributesBySection[sectionName].some(attr => !attr.isHidden);
  }

  getMetaDataValues(metaDataValues: string, index: number = null): any {
    const values = metaDataValues.split(/\s*,\s*/);

    if (index == null) return values;

    return values[index];
  }

  updateBooleanFormControlValue(
    groupName: string,
    controlName: string,
    isChecked: boolean,
    metaValues: any
  ) {
    const selectedValue = isChecked
      ? this.getMetaDataValues(metaValues, 1)
      : this.getMetaDataValues(metaValues, 0);
    if (!this.booleanValues[groupName]) {
      this.booleanValues[groupName] = {};
    }
    this.booleanValues[groupName][controlName] = selectedValue;
  }

  async createContract() {
    if (this.contractForm.valid) {
      this.isLoading = true;
      const data = this.contractForm.value;
      try {
        // Get the selected account object
        const selectedAccount = this.accountList.find(acc => acc.id === data.accountId);

        if (this.id || data.id) {
          this.contract.contractTypeId = data.contractTypeId;
          this.contract.transactionTypeId = data.transactionTypeId;
          this.contract.name = data.name;
          this.contract.accountId = data.accountId;
          this.contract.account = selectedAccount || null;
          await this.contractService
            .updateContract(this.contract, this.id)
            .then((res: any) => {
              this.contract = res;
              this.metadataForm = new FormGroup([]);
              this.attributesBySection = {};
              this.sectionNames = [];
              this.originalContractFormValue = data;
              this.isFormChanged = !this.isFormUnchanged();
            });
        } else {
          // Add account object to the data before saving
          const contractData = {
            ...data,
            account: selectedAccount || null
          };
          await this.contractService.saveContract(contractData).then((res: any) => {
            this.contract = res;
            this.id = res.id;
          });
        }
        this.router.navigate(['/app/contract/edit', this.id]);
        this.initializeMetaForm();
        this.isLoading = false;
        this.stepper.next();
      } catch (error) {
        this.toast.error(JSON.stringify(error), "");
        this.isLoading = false;
      }
    }
  }

  async saveAttributeData() {
    if (this.metadataForm.valid) {
      this.isLoading = true;
      for (const groupName in this.booleanValues) {
        const group = this.booleanValues[groupName];
        const formGroup = this.metadataForm.get(groupName) as FormGroup;

        if (formGroup) {
          for (const controlName in group) {
            formGroup.get(controlName)?.setValue(group[controlName]);
          }
        }
      }
      const data = this.metadataForm.getRawValue();

      const attributeValues: AttributeValues[] = [];

      for (const groupName in data) {
        const group = data[groupName];
        const formGroup = this.metadataForm.get(groupName) as FormGroup;

        if (group) {
          //changed to group instead of formGroup due to formgroup regex 
          for (const controlName in group) {
            const value = group[controlName];
            const attrib = this.tempAttrib.find(
              (option) => option.label == controlName
            );
            const attribute: AttributeValues = new AttributeValues();

            attribute.attributeValue = value;
            if (attrib.metaDataTypeId == 15) {
              attribute.attributeValue = value.join(", ");
            }
            if (attrib.metaDataTypeId == 9) {
              // Handle date fields: if value is empty, null, undefined, or invalid date, set to null
              if (!value || value === '' || (value instanceof Date && (isNaN(value.getTime()) || value.getTime() === 0))) {
                attribute.attributeValue = null;
              } else {
                attribute.attributeValue = attribute.attributeValue;
              }
            }
            attribute.createDate = new Date();
            attribute.updateDate = new Date();
            attribute.tenantId = this.userService.loggedinUser.tenantId;
            attribute.createdBy = this.userFullName;
            attribute.updatedBy = this.userFullName;
            attribute.attributeId = attrib.attributeId;
            if (this.mode && this.values.length > 0) {
              const attValue: AttributeValues = this.values.find(
                (o) => o.attributeId == attrib.attributeId
              );
              attribute.id = attValue?.id;
            }

            attributeValues.push(attribute);
          }
        }
      }

      try {
        if (this.values.length === 0) {
          await this.contractService
            .createContractAttributeValues(attributeValues, this.id)
            .then((attributes: AttributeValues[]) => {
              this.values = attributes;
              this.contract.completedStep =
                this.contract.completedStep > 2
                  ? this.contract.completedStep
                  : 2;
              this.contract.updatedBy =
                this.userService.loggedinUser.id.toString();
              this.toast.success("Attributes added successfully!", "");
              this.contractService
                .updateContract(this.contract, this.id)
                .then((res: Contract) => {
                  this.contract = res;
                });
            });
        } else {
          await this.contractService
            .updateContractTypeValues(attributeValues, this.id)
            .then(() => {
              this.contract.completedStep =
                this.contract.completedStep > 2
                  ? this.contract.completedStep
                  : 2;
              this.toast.success("Attributes updated successfully!", "");
              this.contract.updatedBy =
                this.userService.loggedinUser.id.toString();
              this.contractService
                .updateContract(this.contract, this.id)
                .then((res: Contract) => {
                  this.contract = res;
                  // Removed automatic document generation - user must click "Generate Document" button
                  // this.generateDoc();
                });
            });
        }
        if (this.contract.transactionTypeId == 1) {
          this.initializeTemplate();
          // For own transaction type, go to template selection step (index 2)
          // Use setTimeout to ensure the template step is rendered first
          setTimeout(() => {
            this.stepper.selectedIndex = 2;
          }, 100);
        } else {
          this.initializeValidation();
          // For other transaction types, go to validation step (index 2)
          this.stepper.selectedIndex = 2;
        }

        this.isLoading = false;
      } catch (error) {
        this.toast.error(JSON.stringify(error), "");
        this.isLoading = false;
      }
    }
  }

  async updateTemplate() {
    if (this.selectedTemplateId) {
      this.isLoading = true;
      this.contract.templateId = this.selectedTemplateId;
      this.contract.completedStep =
        this.contract.completedStep > 3 ? this.contract.completedStep : 3;
      this.contract.updateDate = new Date();
      this.contract.updatedBy = this.userService.loggedinUser.id.toString();
      try {
        await this.contractService
          .updateContract(this.contract, this.id)
          .then((res: any) => {
            this.contract = res;
          });

        // If document was already generated, regenerate it with the new template
        if (this.contract.isMandatoryFilled) {
          try {
            // Regenerate document with new template
            await this.contractService.generateDoc(this.id);
            // Refresh contract to get updated document
            await this.contractService
              .refreshContract(this.id)
              .then((res: Contract) => {
                this.contract = res;
              });
            // Clear preview URL to force refresh
            this.previewURL = null;
          } catch (genError) {
            console.error('Error regenerating document:', genError);
            // Continue even if regeneration fails - document might still be valid
          }
        }

        this.initializeValidation();
        this.isLoading = false;
        // For own transaction type, go to validation step (index 3)
        this.stepper.selectedIndex = 3;
      } catch (error) {
        this.toast.error(JSON.stringify(error), "");
        this.isLoading = false;
      }
    } else {
      this.toast.warning("Please select the template to continue!", "");
    }
  }

  async updateContract(formName: FormGroup) {
    if (formName.valid) {
      this.isLoading = true;
      const data = formName.value;
      try {
        await this.contractService
          .updateContract(data, this.id)
          .then((res: any) => {
            if (res.id) {
              this.contract = res;
              this.stepper.next();
            } else {
              this.toast.warning(JSON.stringify(res), "");
            }
            this.isLoading = false;
          });
      } catch (error) {
        this.toast.error(JSON.stringify(error), "");
        this.isLoading = false;
      }
    }
  }


  async saveObligations() {
    // Check for date range validation error
    if (this.obligationsForm.hasError('dateRangeInvalid')) {
      this.toast.error('Start date cannot be greater than end date', '');
      this.markFormGroupTouched();
      return;
    }


    if (this.obligationsForm.valid) {
      const formData = this.obligationsForm.value;
      this.isLoading = true;

      try {
        // Status mapping object
        const statusMapping = {
          'Draft': 0,
          'Active': 1,
          'Overdue': 2,
          'Fulfilled': 3,
          'Cancelled': 4
        };

        // Advance reminder mapping object for entitlementReminderNoticeId (matching HTML form values)
        const advanceReminderMapping = {
          'None': 0,
          '7': 1,
          '15': 2,
          '30': 3
        };

        // Advance reminder string mapping for API (matching HTML form values)
        const advanceReminderStringMapping = {
          'None': null,
          '7': '7 days',
          '15': '15 days',
          '30': '30 days'
        };

        // Map the form data to the obligation payload structure
        const data = {
          id: formData.id,
          description: formData.description,
          oblText: formData.obligationText,
          oblOwner: formData.obligationOwner,
          oblSection: formData.sectionNumber,
          validFromDate: this.formatDateForAPI(formData.agreementStartDate || formData.validFromDate || formData.startDate),
          validToDate: this.formatDateForAPI(formData.agreementEndDate || formData.validToDate || formData.endDate),
          personEmail: formData.responsiblePersonEmail,
          entitlementType: formData.obligationType || formData.entitlementTypeId,
          entitlementFrequency: formData.frequency || formData.entitlementFrequencyId,
          entitlementApprovalId: formData.entitlementApprovalId,
          entitlementReminderNoticeId: formData.entitlementReminderNoticeId || (formData.advanceReminder ? advanceReminderMapping[formData.advanceReminder] : null),
          advanceReminder: formData.advanceReminder ? advanceReminderStringMapping[formData.advanceReminder] : null,
          status: statusMapping[formData.status] || 0,
          fulfilmentDescription: formData.fulfillmentDescription || 'N/A',
          mimeType: formData.mimeType,
        };


        if (!formData.id) {
          await this.contractService
            .saveEntitlement(data, this.id)
            .then((res) => {
              this.toast.success("Obligation added successfully!", "");
              this.resetForm();
              this.closeObligationForm();
              this.getObligations();
            });
        } else {
          await this.contractService
            .editEntitlement(data, this.id)
            .then((res) => {

              // Workaround: Manually update the status, dates, and fulfillment description in the response since API doesn't persist them
              if (res && typeof res === 'object') {
                (res as any).status = data.status; // Use the status we sent, not what API returned
                (res as any).validFromDate = data.validFromDate; // Use the date we sent, not what API returned
                (res as any).validToDate = data.validToDate; // Use the date we sent, not what API returned
                (res as any).fulfilmentDescription = data.fulfilmentDescription; // Use the fulfillment description we sent
              }

              this.lastUpdatedObligationId = data.id; // Track the updated obligation ID
              this.lastUpdatedObligationData = res; // Store the updated obligation data

              // Debug: Log the API response to see if it includes fulfillment description
              console.log('API response after update:', res);
              console.log('Fulfillment description in API response:', (res as any).fulfilmentDescription);
              this.toast.success("Obligation updated successfully!", "");
              this.resetForm();
              this.closeObligationForm();
              // Add a small delay to ensure the update is committed
              setTimeout(() => {
                this.getObligations();
              }, 500);
            });
        }
      } catch (error) {
        this.toast.error("Something went wrong! Please try again later.", "");
        console.error('Save obligation error:', error);
      }
      this.isLoading = false;
    } else {
      this.markFormGroupTouched();
      this.toast.error('Please fill in all required fields', '');
    }
  }

  resetForm() {
    this.obligationsForm.reset();
    Object.keys(this.obligationsForm.controls).forEach((key) => {
      this.obligationsForm.get(key)?.setErrors(null);
    });
  }

  markFormGroupTouched() {
    Object.keys(this.obligationsForm.controls).forEach(key => {
      const control = this.obligationsForm.get(key);
      control?.markAsTouched();
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue?.toLowerCase();
    this.dataSource.filter = filterValue;
    // PrimeNG table handles pagination internally, no need to reset paginator
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === "") {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || "").toString()?.toLowerCase();
      const valueB = (b[event.active] || "").toString()?.toLowerCase();

      return this.compare(valueA, valueB, event.direction === "asc");
    });
    // PrimeNG table handles pagination internally, no need to reset paginator
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // Helper method to reset file inputs
  private resetFileInput(inputType: 'uploadFile' | 'uploadPDF' | 'uploadSignedFile'): void {
    let fileInput: ElementRef<HTMLInputElement> | undefined;

    switch (inputType) {
      case 'uploadFile':
        fileInput = this.uploadFileInput;
        break;
      case 'uploadPDF':
        fileInput = this.uploadPDFInput;
        break;
      case 'uploadSignedFile':
        fileInput = this.uploadSignedFileInput;
        break;
    }

    if (fileInput && fileInput.nativeElement) {
      fileInput.nativeElement.value = '';
    }
  }

  // Add a new method to handle chip selection
  selectSuggestion(sectionName: string, fieldName: string, value: string): void {
    const control = this.metadataForm.get(sectionName)?.get(fieldName);
    if (control) {
      control.setValue(value);
      // Clear suggestions after selection to make chips disappear
      this.fieldSuggestions[fieldName] = [];
    }
  }

  // New methods for AI analysis and file handling
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  clearFile(): void {
    this.selectedFile = null;
  }

  async analyzeContract(): Promise<void> {
    if (!this.selectedFile) {
      this.toast.warning('Please select a file first', '');
      return;
    }

    this.isAnalyzing = true;
    try {
      const base64 = await this.fileToBase64(this.selectedFile);
      const fileType = this.selectedFile.type === 'application/pdf' ? 'pdf' : 'docx';

      const response = await fetch('https://contract-ai-1007512864935.europe-west2.run.app/obligations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          base_64: base64,
          type_file: fileType
        })
      });

      if (response.ok) {
        const obligations = await response.json();
        this.aiAnalysisResults = obligations;
        this.obligationData = obligations;
        this.obligationSource.data = obligations;
        this.toast.success('Contract analyzed successfully!', '');
      } else {
        throw new Error('Analysis failed');
      }
    } catch (error) {
      this.toast.error('Failed to analyze contract. Please try again.', '');
      console.error('Analysis error:', error);
    } finally {
      this.isAnalyzing = false;
    }
  }

  async extractObligationsFromUploadedContract(): Promise<void> {
    if (!this.fileToUpload) {
      return;
    }

    this.isAnalyzing = true;
    try {
      const base64 = await this.fileToBase64(this.fileToUpload);
      const fileType = this.fileToUpload.type === 'application/pdf' ? 'pdf' : 'docx';

      const response = await fetch('https://contract-ai-1007512864935.europe-west2.run.app/obligations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          base_64: base64,
          type_file: fileType
        })
      });

      if (response.ok) {
        const obligations = await response.json();
        this.aiAnalysisResults = obligations;
        this.obligationData = obligations;
        this.obligationSource.data = obligations;
        this.toast.success('Obligations extracted from uploaded contract!', '');
      } else {
        throw new Error('Obligation extraction failed');
      }
    } catch (error) {
      this.toast.error('Failed to extract obligations from contract. You can manually add them later.', '');
      console.error('Obligation extraction error:', error);
    } finally {
      this.isAnalyzing = false;
    }
  }

  async extractObligationsFromContractDocument(): Promise<void> {
    if (!this.contract?.isMandatoryFilled) {
      return;
    }

    this.isAnalyzing = true;
    try {
      // Get the contract document URL
      const documentUrl = await this.contractService.downloadDocument(this.id).toPromise();

      if (!documentUrl) {
        throw new Error('No document URL found');
      }

      // Fetch the document
      const documentResponse = await fetch(documentUrl);
      if (!documentResponse.ok) {
        throw new Error('Failed to fetch document');
      }

      // Convert to blob and then to base64
      const blob = await documentResponse.blob();
      const base64 = await this.blobToBase64(blob);

      // Determine file type from URL or content type
      const fileType = documentUrl.toLowerCase().includes('.pdf') || blob.type === 'application/pdf' ? 'pdf' : 'docx';

      // Extract obligations using AI
      const response = await fetch('https://contract-ai-1007512864935.europe-west2.run.app/obligations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          base_64: base64,
          type_file: fileType
        })
      });

      if (response.ok) {
        const obligations = await response.json();
        this.aiAnalysisResults = obligations;

        // Auto-save all extracted obligations to database
        await this.saveAllAIObligations(obligations);

        // Refresh the obligations list to show saved data
        await this.getObligations();

        this.toast.success(`${obligations.length} obligations extracted and saved from contract document!`, '');
      } else {
        throw new Error('Obligation extraction failed');
      }
    } catch (error) {
      this.toast.error('Failed to extract obligations from contract document. You can manually add them later.', '');
      console.error('Obligation extraction error:', error);
    } finally {
      this.isAnalyzing = false;
    }
  }

  // Manual extraction method for the button
  async extractObligationsManually(): Promise<void> {
    if (!this.contract?.isMandatoryFilled) {
      this.toast.warning('Please upload a contract document first before extracting obligations.', '');
      return;
    }

    if (!this.isContractEligibleForObligations()) {
      this.toast.warning('Only approved contracts are eligible for obligation management.', '');
      return;
    }

    // Allow re-extraction - users can extract multiple times and add to existing obligations

    this.isAnalyzing = true;
    try {
      // Get the contract document URL
      const documentUrl = await this.contractService.downloadDocument(this.id).toPromise();

      if (!documentUrl) {
        throw new Error('No document URL found');
      }

      // Fetch the document
      const documentResponse = await fetch(documentUrl);
      if (!documentResponse.ok) {
        throw new Error('Failed to fetch document');
      }

      // Convert to blob and then to base64
      const blob = await documentResponse.blob();
      const base64 = await this.blobToBase64(blob);

      // Determine file type from URL or content type
      const fileType = documentUrl.toLowerCase().includes('.pdf') || blob.type === 'application/pdf' ? 'pdf' : 'docx';

      // Extract obligations using AI
      const response = await fetch('https://contract-ai-1007512864935.europe-west2.run.app/obligations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          base_64: base64,
          type_file: fileType
        })
      });

      if (response.ok) {
        const obligations = await response.json();
        this.aiAnalysisResults = obligations;

        // Auto-save all extracted obligations to database
        await this.saveAllAIObligations(obligations);

        // Refresh the obligations list to show saved data
        await this.getObligations();

        this.toast.success(`${obligations.length} obligations extracted and saved successfully using AI!`, '');
      } else {
        throw new Error('Obligation extraction failed');
      }
    } catch (error) {
      this.toast.error('Failed to extract obligations. Please try again or add them manually.', '');
      console.error('Obligation extraction error:', error);
    } finally {
      this.isAnalyzing = false;
    }
  }

  // Method to save all AI-extracted obligations to database
  async saveAllAIObligations(obligations: any[]): Promise<void> {
    try {
      const currentDate = new Date();
      const oneYearLater = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

      // Process each AI extracted obligation
      for (const obligation of obligations) {
        // Map AI-extracted data to the correct payload structure based on your JSON format
        const obligationData = {
          description: obligation['Description'] || obligation.description || '',
          oblText: obligation['Obligation Text'] || obligation.obligationText || '',
          oblOwner: obligation['Owned By'] || obligation.obligationOwner || 'AI Extracted',
          oblSection: obligation['Section Number'] || obligation.sectionNumber || '',
          validFromDate: currentDate.toISOString(),
          validToDate: oneYearLater.toISOString(),
          personEmail: 'NA', // Default email for AI extracted
          entitlementType: obligation['Obligation Type'] || obligation.obligationType || 'General',
          entitlementFrequency: obligation['Frequency'] || obligation.frequency || 'One-time',
          entitlementApprovalId: ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
          entitlementReminderNoticeId: ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
          status: 0 // Draft status
        };


        // Save each obligation to database
        await this.contractService.saveEntitlement(obligationData, this.id);
      }

    } catch (error) {
      console.error('Error saving AI obligations:', error);
      throw error; // Re-throw to be handled by the calling method
    }
  }

  // Method to save selected AI-extracted obligations to database
  async saveSelectedAIObligations(): Promise<void> {
    const selectedObligations = this.obligationSelection.selected.filter(obligation => obligation.isAIExtracted);

    if (selectedObligations.length === 0) {
      this.toast.warning('Please select at least one AI extracted obligation to save.', '');
      return;
    }

    try {
      const currentDate = new Date();
      const oneYearLater = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

      // Process each selected AI extracted obligation
      for (const obligation of selectedObligations) {
        // Map AI-extracted data to the correct payload structure
        const obligationData = {
          id: null,
          obligationOwner: obligation['Owned By'] || obligation.obligationOwner || 'AI Extracted',
          obligationType: obligation['Obligation Type'] || obligation.obligationType || 'General',
          obligationText: obligation['Obligation Text'] || obligation.obligationText || obligation.description || '',
          frequency: obligation['Frequency'] || obligation.frequency || 'One-time',
          startDate: obligation['Start Date'] ? new Date(obligation['Start Date']) : null,
          agreementStartDate: currentDate,
          endDate: obligation['End Date'] ? new Date(obligation['End Date']) : null,
          agreementEndDate: oneYearLater,
          targetDate: obligation['Target Date'] ? new Date(obligation['Target Date']) : null,
          responsiblePersonEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail,
          advanceReminder: this.mapAdvanceReminderForForm(obligation['Advance Reminder'] || obligation.advanceReminder),
          fulfillmentDescription: obligation['fulfilmentDescription'] || obligation.fulfilmentDescription || obligation['fulfillmentDescription'] || obligation.fulfillmentDescription || '',
          description: obligation['Description'] || obligation.description || '',
          personEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail || 'NA',
          entitlementApprovalId: ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
          entitlementFrequencyId: ((this.frequencies as any[])?.length > 0 ? (this.frequencies as any[])[0].id : 1),
          entitlementReminderNoticeId: ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
          entitlementTypeId: ((this.obligationTypes as any[])?.length > 0 ? (this.obligationTypes as any[])[0].id : 1),
          entitlementTimeLineId: ((this.timeLines as any[])?.length > 0 ? (this.timeLines as any[])[0].id : 1),
          validFromDate: currentDate,
          validToDate: oneYearLater,
          createdBy: this.userFullName
        };

        // Save each obligation to database
        await this.contractService.saveEntitlement(obligationData, this.id);
      }

      // Remove saved obligations from the table
      const remainingObligations = this.obligationData.filter(obligation =>
        !selectedObligations.includes(obligation)
      );
      this.obligationData = remainingObligations;
      this.obligationSource.data = remainingObligations;

      // Clear selection
      this.obligationSelection.clear();

      // Refresh the obligations list to show saved data
      await this.getObligations();

      this.toast.success(`${selectedObligations.length} AI extracted obligation(s) saved successfully!`, '');

    } catch (error) {
      console.error('Error saving selected AI obligations:', error);
      this.toast.error('Some obligations could not be saved. Please check and add them manually if needed.', '');
    }
  }

  // Helper method to check if there are AI extracted obligations
  hasAIExtractedObligations(): boolean {
    return this.obligationData.some(ob => ob.isAIExtracted);
  }

  // Helper method to check if there are selected AI extracted obligations
  hasSelectedAIObligations(): boolean {
    return this.obligationSelection.selected.some(ob => ob.isAIExtracted);
  }

  // Method to save AI-extracted obligations to database (kept for backward compatibility)
  async saveExtractedObligations(obligations: any[]): Promise<void> {
    try {
      const currentDate = new Date();
      const oneYearLater = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

      // Process each extracted obligation
      for (const obligation of obligations) {
        // Map AI-extracted data to the correct payload structure
        const obligationData = {
          id: null,
          obligationOwner: obligation['Owned By'] || obligation.obligationOwner || 'AI Extracted',
          obligationType: obligation['Obligation Type'] || obligation.obligationType || 'General',
          obligationText: obligation['Obligation Text'] || obligation.obligationText || obligation.description || '',
          frequency: obligation['Frequency'] || obligation.frequency || 'One-time',
          startDate: obligation['Start Date'] ? new Date(obligation['Start Date']) : null,
          agreementStartDate: currentDate,
          endDate: obligation['End Date'] ? new Date(obligation['End Date']) : null,
          agreementEndDate: oneYearLater,
          targetDate: obligation['Target Date'] ? new Date(obligation['Target Date']) : null,
          responsiblePersonEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail,
          advanceReminder: this.mapAdvanceReminderForForm(obligation['Advance Reminder'] || obligation.advanceReminder),
          fulfillmentDescription: obligation['fulfilmentDescription'] || obligation.fulfilmentDescription || obligation['fulfillmentDescription'] || obligation.fulfillmentDescription || '',
          description: obligation['Description'] || obligation.description || '',
          personEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail || 'NA',
          entitlementApprovalId: ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
          entitlementFrequencyId: ((this.frequencies as any[])?.length > 0 ? (this.frequencies as any[])[0].id : 1),
          entitlementReminderNoticeId: ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
          entitlementTypeId: ((this.obligationTypes as any[])?.length > 0 ? (this.obligationTypes as any[])[0].id : 1),
          entitlementTimeLineId: ((this.timeLines as any[])?.length > 0 ? (this.timeLines as any[])[0].id : 1),
          validFromDate: currentDate,
          validToDate: oneYearLater,
          createdBy: this.userFullName
        };

        // Save each obligation to database
        await this.contractService.saveEntitlement(obligationData, this.id);
      }

      // Refresh the obligations list to show saved data
      await this.getObligations();

    } catch (error) {
      this.toast.error('Some obligations could not be saved. Please check and add them manually if needed.', '');
    }
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result as string;
        // Remove the data URL prefix to get just the base64 string
        const base64Data = base64.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = error => reject(error);
    });
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const base64 = reader.result as string;
        // Remove the data URL prefix to get just the base64 string
        const base64Data = base64.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = error => reject(error);
    });
  }

  editObligationFromTable(obligation: any): void {
    // Map the obligation data to include the display fields expected by the HTML
    this.currentObligation = {
      ...obligation,
      SectionNumber: obligation['Section Number'] || obligation.sectionNumber || 'NA',
      sectionTitle: obligation['Section Title'] || obligation.sectionTitle || 'NA',
      description: obligation['Description'] || obligation.description || 'NA'
    };

    // Show form and enable for editing
    this.showObligationForm = true;
    this.viewMode = false;
    this.obligationsForm.enable();

    const formData = {
      id: obligation.id || null,
      obligationText: obligation['Obligation Text'] || obligation.obligationText || '',
      obligationType: obligation['Obligation Type'] || obligation.obligationType || '',
      obligationOwner: obligation['Owned By'] || obligation.obligationOwner || '',
      sectionNumber: obligation['Section Number'] || obligation.sectionNumber || '',
      frequency: obligation['Frequency'] || obligation.frequency || '',
      status: obligation['Status'] || obligation.status || 'Draft',
      startDate: obligation['Start Date'] ? new Date(obligation['Start Date']) : (obligation.startDate ? new Date(obligation.startDate) : null),
      endDate: obligation['End Date'] ? new Date(obligation['End Date']) : (obligation.endDate ? new Date(obligation.endDate) : null),
      agreementStartDate: this.parseDateFromAPI(obligation.validFromDate),
      agreementEndDate: this.parseDateFromAPI(obligation.validToDate),
      responsiblePersonEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail || '',
      advanceReminder: this.mapAdvanceReminderForForm(obligation['Advance Reminder'] || obligation.advanceReminder),
      fulfillmentDescription: obligation['fulfilmentDescription'] || obligation.fulfilmentDescription || obligation['fulfillmentDescription'] || obligation.fulfillmentDescription || '',
      // Legacy fields
      description: obligation['Description'] || obligation.Description || '',
      personEmail: obligation.personEmail || obligation.responsiblePersonEmail,
      entitlementApprovalId: obligation.entitlementApprovalId || ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
      entitlementFrequencyId: obligation.entitlementFrequencyId || ((this.frequencies as any[])?.length > 0 ? (this.frequencies as any[])[0].id : 1),
      entitlementReminderNoticeId: obligation.entitlementReminderNoticeId || ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
      entitlementTypeId: obligation.entitlementTypeId || ((this.obligationTypes as any[])?.length > 0 ? (this.obligationTypes as any[])[0].id : 1),
      entitlementTimeLineId: obligation.entitlementTimeLineId || ((this.timeLines as any[])?.length > 0 ? (this.timeLines as any[])[0].id : 1),
      validFromDate: this.parseDateFromAPI(obligation.validFromDate),
      validToDate: this.parseDateFromAPI(obligation.validToDate)
    };

    this.obligationsForm.patchValue(formData);
    this.scrollToTop();
  }

  viewObligationDetails(obligation: any): void {
    // Debug: Log the obligation data being received
    console.log('Obligation data received:', obligation);
    console.log('Fulfillment description from obligation:', obligation.fulfilmentDescription);

    // Reset form first to clear any previous data
    this.obligationsForm.reset();

    // Map the obligation data to include the display fields expected by the HTML
    this.currentObligation = {
      ...obligation,
      SectionNumber: obligation['Section Number'] || obligation.sectionNumber || 'NA',
      // sectionTitle: obligation['Section Title'] || obligation.sectionTitle || 'NA',
      description: obligation['Description'] || obligation.description || 'NA'
    };

    // Show form for viewing
    this.showObligationForm = true;

    this.obligationsForm.patchValue({
      id: obligation.id || null,
      obligationText: obligation['Obligation Text'] || obligation.obligationText || '',
      obligationType: obligation['Obligation Type'] || obligation.obligationType || '',
      obligationOwner: obligation['Owned By'] || obligation.obligationOwner || '',
      sectionNumber: obligation['Section Number'] || obligation.sectionNumber || '',
      frequency: obligation['Frequency'] || obligation.frequency || '',
      status: obligation['Status'] || obligation.status || 'Draft',
      startDate: obligation['Start Date'] ? new Date(obligation['Start Date']) : (obligation.startDate ? new Date(obligation.startDate) : null),
      endDate: obligation['End Date'] ? new Date(obligation['End Date']) : (obligation.endDate ? new Date(obligation.endDate) : null),
      agreementStartDate: this.parseDateFromAPI(obligation.validFromDate),
      agreementEndDate: this.parseDateFromAPI(obligation.validToDate),
      responsiblePersonEmail: obligation['Responsible Person'] || obligation.responsiblePersonEmail || '',
      advanceReminder: this.mapAdvanceReminderForForm(obligation['Advance Reminder'] || obligation.advanceReminder),
      fulfillmentDescription: obligation['fulfilmentDescription'] || obligation.fulfilmentDescription || obligation['fulfillmentDescription'] || obligation.fulfillmentDescription || '',
      // Legacy fields
      description: obligation['Description'] || obligation.description || '',
      personEmail: obligation.personEmail || obligation.responsiblePersonEmail || '',
      entitlementApprovalId: obligation.entitlementApprovalId || ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
      entitlementFrequencyId: obligation.entitlementFrequencyId || ((this.frequencies as any[])?.length > 0 ? (this.frequencies as any[])[0].id : 1),
      entitlementReminderNoticeId: obligation.entitlementReminderNoticeId || ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
      entitlementTypeId: obligation.entitlementTypeId || ((this.obligationTypes as any[])?.length > 0 ? (this.obligationTypes as any[])[0].id : 1),
      entitlementTimeLineId: obligation.entitlementTimeLineId || ((this.timeLines as any[])?.length > 0 ? (this.timeLines as any[])[0].id : 1),
      validFromDate: this.parseDateFromAPI(obligation.validFromDate),
      validToDate: this.parseDateFromAPI(obligation.validToDate)
    });

    // Debug: Log the form value after patching
    console.log('Form value after patching:', this.obligationsForm.value);
    console.log('Fulfillment description in form:', this.obligationsForm.get('fulfillmentDescription')?.value);

    this.obligationsForm.disable();
    // Enable fulfillment description field even in view mode
    // this.obligationsForm.get('fulfillmentDescription')?.enable();
    this.viewMode = true;
    this.scrollToTop();
  }

  async deleteObligation(obligation: any): Promise<void> {
    // Show confirmation dialog
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      enterAnimationDuration: "400ms",
      exitAnimationDuration: "500ms",
      data: {
        title: 'Delete Obligation',
        message: `Are you sure you want to delete this obligation? This action cannot be undone.`,
        confirmText: 'Yes, Delete',
        cancelText: 'Cancel',
        confirmButtonColor: 'warn',
        confirmFunction: () => this.performDeleteObligation(obligation),
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // The deletion was successful, no need to do anything here
        // as performDeleteObligation already handles the table update
      }
    });
  }

  // Multiple selection methods for obligations
  isAllObligationsSelected() {
    const numSelected = this.obligationSelection.selected.length;
    const numRows = this.obligationData.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggleObligations() {
    this.isAllObligationsSelected() ?
      this.obligationSelection.clear() :
      this.obligationData.forEach(row => this.obligationSelection.select(row));
  }

  checkboxLabelObligations(row?: any): string {
    if (!row) {
      return `${this.isAllObligationsSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.obligationSelection.isSelected(row) ? 'deselect' : 'select'} row ${row['Sr No.']}`;
  }

  getSelectedObligationsCount(): number {
    return this.obligationSelection.selected.length;
  }

  // Check if contract is approved and eligible for obligation management
  isContractEligibleForObligations(): boolean {
    // Contract must be approved (statusId 3 or higher) to manage obligations
    return this.contract && this.contract.statusId >= 3;
  }

  // Get contract approval status message
  getContractApprovalMessage(): string {
    if (!this.contract) {
      return 'Contract not found';
    }

    switch (this.contract.statusId) {
      case 1:
        return 'Contract is pending approval. Obligations can only be managed after contract approval.';
      case 2:
        return 'Contract is under review. Obligations can only be managed after contract approval.';
      case 3:
        return 'Contract is approved. You can now manage obligations.';
      case 4:
        return 'Contract is approved. You can now manage obligations.';
      case 5:
        return 'Contract is approved. You can now manage obligations.';
      case 6:
        return 'Contract is signed. You can now manage obligations.';
      default:
        return 'Contract status is unknown. Please contact administrator.';
    }
  }

  // Bulk delete obligations
  async deleteSelectedObligations(): Promise<void> {
    const selectedObligations = this.selectedObligations;

    if (selectedObligations.length === 0) {
      this.toast.warning('Please select obligations to delete', '');
      return;
    }

    // Show confirmation dialog
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      enterAnimationDuration: "400ms",
      exitAnimationDuration: "500ms",
      data: {
        title: 'Delete Multiple Obligations',
        message: `Are you sure you want to delete ${selectedObligations.length} selected obligation(s)? This action cannot be undone.`,
        confirmText: 'Yes, Delete All',
        cancelText: 'Cancel',
        confirmButtonColor: 'warn',
        confirmFunction: () => this.performBulkDeleteObligations(selectedObligations),
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // The deletion was successful, no need to do anything here
        // as performBulkDeleteObligations already handles the table update
      }
    });
  }

  // Remove single obligation from table without API call
  private async performDeleteObligation(obligation: any): Promise<void> {
    try {
      this.isLoading = true;

      // Call the delete API
      await this.contractService.deleteEntitlement(obligation.id, this.id);

      // Remove the obligation from the table data source
      const currentData = this.obligationData;
      const updatedData = currentData.filter(item => item.id !== obligation.id);
      this.obligationData = updatedData;
      this.obligationSource.data = updatedData;

      // Clear selection if the deleted item was selected
      this.obligationSelection.deselect(obligation);

      this.toast.success('Obligation deleted successfully', '');
      this.isLoading = false;
    } catch (error) {
      console.error('Error deleting obligation:', error);

      try {
        const currentData = this.obligationData;
        const updatedData = currentData.filter(item => item.id !== obligation.id);
        this.obligationData = updatedData;
        this.obligationSource.data = updatedData;
        this.obligationSelection.deselect(obligation);

        // Refresh the obligations to get the latest data from the server
        await this.getObligations();

        this.toast.success('Obligation deleted successfully', '');
      } catch (refreshError) {
        this.toast.error('Obligation may have been deleted, but there was an error updating the table', '');
      }

      this.isLoading = false;
    }
  }

  // Remove multiple obligations from table with API calls
  private async performBulkDeleteObligations(obligations: any[]): Promise<void> {
    try {
      this.isLoading = true;

      // Call the delete API for each obligation
      const deletePromises = obligations.map(obligation =>
        this.contractService.deleteEntitlement(obligation.id, this.id)
      );

      await Promise.all(deletePromises);

      // Remove all selected obligations from the table data source
      const currentData = this.obligationData;
      const updatedData = currentData.filter(item => !obligations.some(obligation => obligation.id === item.id));
      this.obligationData = updatedData;
      this.obligationSource.data = updatedData;

      // Clear selection after deletion
      this.clearObligationSelection();

      this.toast.success(`${obligations.length} obligation(s) deleted successfully`, '');
      this.isLoading = false;
    } catch (error) {
      console.error('Error deleting obligations:', error);
      try {
        const currentData = this.obligationData;
        const updatedData = currentData.filter(item => !obligations.some(obligation => obligation.id === item.id));
        this.obligationData = updatedData;
        this.obligationSource.data = updatedData;
        this.clearObligationSelection();

        // Refresh the obligations to get the latest data from the server
        await this.getObligations();

        this.toast.success(`${obligations.length} obligation(s) deleted successfully`, '');
      } catch (refreshError) {
        this.toast.error('Obligations may have been deleted, but there was an error updating the table', '');
      }

      this.isLoading = false;
    }
  }

  // Responsible Person Modal Methods
  openResponsiblePersonModal(): void {
    const dialogRef = this.dialog.open(AddSignatoryComponent, {
      enterAnimationDuration: '400ms',
      exitAnimationDuration: '500ms',
      width: '40%',
      data: {
        id: this.id,
        isResponsiblePerson: true, // Flag to indicate this is for responsible person selection
        addFunction: (name: string, email: string) => this.selectResponsiblePerson(name, email)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // The result will be handled by the selectResponsiblePerson callback
    });
  }

  selectResponsiblePerson(name: string, email: string): boolean {
    // Update the form with selected user's email
    this.obligationsForm.patchValue({
      responsiblePersonEmail: email
    });

    this.toast.success('Responsible person selected successfully!', '');
    return true; // Return true to indicate success
  }

  closeObligationForm(): void {
    this.showObligationForm = false;
    this.currentObligation = null;
    this.obligationsForm.reset();
    this.viewMode = false;
  }

  // Method to open form for adding new obligation
  addNewObligation(): void {
    if (!this.isContractEligibleForObligations()) {
      this.toast.warning('Only approved contracts are eligible for obligation management.', '');
      return;
    }

    this.resetObligationForm();
    this.showObligationForm = true;
    this.currentObligation = null;
    this.viewMode = false;
    this.obligationsForm.enable();

    // Set default values for new obligation
    const currentDate = new Date();
    const oneYearLater = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

    this.obligationsForm.patchValue({
      status: 'Draft',
      // Set default dates - use agreement dates as primary
      agreementStartDate: currentDate,
      agreementEndDate: oneYearLater,
      validFromDate: currentDate,
      validToDate: oneYearLater,
      // Set default values for required fields
      personEmail: 'NA', // Required field, will be updated on save
      responsiblePersonEmail: 'NA',
      entitlementApprovalId: ((this.approvals as any[])?.length > 0 ? (this.approvals as any[])[0].id : 1),
      entitlementFrequencyId: ((this.frequencies as any[])?.length > 0 ? (this.frequencies as any[])[0].id : 1),
      entitlementReminderNoticeId: ((this.reminderdays as any[])?.length > 0 ? (this.reminderdays as any[])[0].id : 1),
      entitlementTypeId: ((this.obligationTypes as any[])?.length > 0 ? (this.obligationTypes as any[])[0].id : 1),
      entitlementTimeLineId: ((this.timeLines as any[])?.length > 0 ? (this.timeLines as any[])[0].id : 1)
    });

    this.scrollToTop();
  }


  getObligationTypeClass(type: string): string {
    const typeMap: { [key: string]: string } = {
      'Data Protection': 'data-protection',
      'Transaction': 'transaction',
      'Compliance': 'compliance',
      'Payment': 'payment'
    };
    return typeMap[type] || 'default';
  }

  resetObligationForm(): void {
    this.obligationsForm.reset();
    this.currentObligation = null;
    this.viewMode = false;
    this.obligationsForm.enable();
    Object.keys(this.obligationsForm.controls).forEach((key) => {
      this.obligationsForm.get(key)?.setErrors(null);
    });
  }

  getStatusText(status: any): string {
    if (status === 1 || status === '1') {
      return 'Active';
    } else if (status === 0 || status === '0') {
      return 'Draft';
    } else if (status === 2 || status === '2') {
      return 'Completed';
    } else if (status === 3 || status === '3') {
      return 'Cancelled';
    } else if (typeof status === 'string') {
      return status; // Return as-is if it's already a string
    }
    return 'Draft'; // Default fallback
  }

  // Check if fulfillment file is available for an obligation
  hasFulfillmentFile(obligationId: number): boolean {
    return this.obligationsWithFiles.has(obligationId);
  }

  // Check if a file exists for an obligation (async check)
  async checkFileExists(obligationId: number): Promise<boolean> {
    try {
      const response = await this.contractService.downloadFulfillmentFile(this.id, obligationId);

      // Check if response contains a valid download URL
      let downloadUrl: string;
      if (typeof response === 'string') {
        downloadUrl = response;
      } else if (response && typeof response === 'object' && 'body' in response) {
        downloadUrl = (response as any).body;
      } else {
        return false;
      }

      if (!downloadUrl || !downloadUrl.startsWith('http')) {
        return false;
      }

      // If we get a valid URL, we know the file exists
      this.obligationsWithFiles.add(obligationId);

      // Try to extract filename from URL and store it
      const urlParts = downloadUrl.split('/');
      const lastPart = urlParts[urlParts.length - 1];
      const fileName = lastPart.split('?')[0]; // Remove query parameters

      if (fileName && fileName.includes('.')) {
        this.obligationFileInfo.set(obligationId, {
          name: fileName,
          type: 'application/octet-stream' // Generic binary type
        });
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  // Check files for visible obligations (first 5 to avoid too many API calls)
  async checkFilesForVisibleObligations(): Promise<void> {
    const visibleObligations = this.obligationData.slice(0, 5); // Check first 5 obligations

    for (const obligation of visibleObligations) {
      if (obligation.id) {
        try {
          await this.checkFileExists(obligation.id);
        } catch (error) {
          // Silently ignore errors for individual file checks
          console.log(`Could not check file for obligation ${obligation.id}:`, error);
        }
      }
    }
  }

  // Get user-friendly file type display
  getFileTypeDisplay(fileType: string): string {
    const typeMap: { [key: string]: string } = {
      'application/pdf': 'PDF',
      'application/msword': 'DOC',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
      'application/vnd.ms-excel': 'XLS',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
      'application/vnd.ms-powerpoint': 'PPT',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
      'image/jpeg': 'JPEG',
      'image/jpg': 'JPG',
      'image/png': 'PNG',
      'image/gif': 'GIF',
      'image/bmp': 'BMP',
      'image/tiff': 'TIFF',
      'text/plain': 'TXT',
      'text/csv': 'CSV',
      'application/zip': 'ZIP',
      'application/x-rar-compressed': 'RAR',
      'application/x-7z-compressed': '7Z',
      'application/octet-stream': 'FILE'
    };

    return typeMap[fileType] || fileType.split('/')[1]?.toUpperCase() || 'FILE';
  }

  // Get appropriate file icon based on file type
  getFileIcon(fileType: string): string {
    if (fileType.startsWith('image/')) {
      return 'image';
    } else if (fileType.includes('pdf')) {
      return 'picture_as_pdf';
    } else if (fileType.includes('word') || fileType.includes('document')) {
      return 'description';
    } else if (fileType.includes('excel') || fileType.includes('spreadsheet')) {
      return 'table_chart';
    } else if (fileType.includes('powerpoint') || fileType.includes('presentation')) {
      return 'slideshow';
    } else if (fileType.includes('zip') || fileType.includes('rar') || fileType.includes('7z')) {
      return 'folder_zip';
    } else if (fileType.includes('text')) {
      return 'text_snippet';
    } else {
      return 'attach_file';
    }
  }

  // Format file size for display
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Detect file type from blob (basic detection)
  private detectFileTypeFromBlob(blob: Blob): string | null {
    const mimeType = blob.type;
    if (mimeType && mimeType !== 'application/octet-stream') {
      return mimeType;
    }
    return null;
  }

  // Get file extension from MIME type
  private getExtensionFromMimeType(mimeType: string): string {
    const mimeToExt: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/bmp': 'bmp',
      'image/tiff': 'tiff',
      'text/plain': 'txt',
      'text/csv': 'csv',
      'application/zip': 'zip',
      'application/x-rar-compressed': 'rar',
      'application/x-7z-compressed': '7z'
    };

    return mimeToExt[mimeType] || 'file';
  }


  // Fulfillment file upload
  onFulfillmentFileSelected(event: any): void {
    console.log('File selected:', event);
    const file = event.target.files[0];
    if (file) {
      console.log('File details:', file);
      this.fulfillmentFile = file;
      this.toast.success(`File selected: ${file.name}`, '');
    } else {
      console.log('No file selected');
    }
  }

  // Remove selected file
  removeSelectedFile(): void {
    this.fulfillmentFile = null;
    // Clear the file input
    if (this.fulfillmentFileInput) {
      this.fulfillmentFileInput.nativeElement.value = '';
    }
    this.toast.info('File selection removed', '');
  }

  async uploadFulfillmentFile(): Promise<void> {
    if (!this.fulfillmentFile || !this.currentObligation?.id) {
      this.toast.error('Please select a file and ensure obligation is saved first', '');
      return;
    }

    this.fulfillmentFileUploading = true;
    try {
      await this.contractService.uploadFulfillmentFile(
        this.fulfillmentFile,
        this.id,
        this.currentObligation.id
      );
      this.toast.success('Fulfillment file uploaded successfully!', '');
      // Add obligation to the set of obligations with files and store file info
      if (this.currentObligation?.id) {
        this.obligationsWithFiles.add(this.currentObligation.id);
        this.obligationFileInfo.set(this.currentObligation.id, {
          name: this.fulfillmentFile.name,
          type: this.fulfillmentFile.type
        });
      }
      this.fulfillmentFile = null;
      // Clear the file input
      if (this.fulfillmentFileInput) {
        this.fulfillmentFileInput.nativeElement.value = '';
      }
    } catch (error) {
      console.error('Error uploading fulfillment file:', error);
      this.toast.error('Failed to upload fulfillment file. Please try again.', '');
    } finally {
      this.fulfillmentFileUploading = false;
    }
  }

  async downloadFulfillmentFile(obligationId: number): Promise<void> {
    if (!obligationId) {
      this.toast.error('Invalid obligation ID', '');
      return;
    }

    // Check if file exists first
    if (!this.hasFulfillmentFile(obligationId)) {
      const fileExists = await this.checkFileExists(obligationId);
      if (!fileExists) {
        this.toast.error('No fulfillment file available for this obligation', '');
        return;
      }
    }

    this.fulfillmentFileDownloading = true;
    try {
      // First, get the signed URL from the API
      const response = await this.contractService.downloadFulfillmentFile(this.id, obligationId);

      // Check if response is a string (URL) or an object with body property
      let downloadUrl: string;
      if (typeof response === 'string') {
        downloadUrl = response;
      } else if (response && typeof response === 'object' && 'body' in response) {
        downloadUrl = (response as any).body;
      } else {
        throw new Error('Invalid response format from download API');
      }

      if (!downloadUrl) {
        throw new Error('No download URL provided');
      }

      // Extract filename from URL for better download experience
      const urlParts = downloadUrl.split('/');
      const lastPart = urlParts[urlParts.length - 1];
      const fileName = lastPart.split('?')[0]; // Remove query parameters

      // Use a single, reliable download approach
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName || `fulfillment_${obligationId}.pdf`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';

      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.toast.success('Fulfillment file download started!', '');
    } catch (error) {
      console.error('Error downloading fulfillment file:', error);

      // Check if it's a 404 or file not found error
      if (error && typeof error === 'object' && 'status' in error && (error as any).status === 404) {
        this.toast.error('No fulfillment file available for this obligation', '');
      } else if (error && typeof error === 'string' && error.includes('404')) {
        this.toast.error('No fulfillment file available for this obligation', '');
      } else {
        this.toast.error('Failed to download fulfillment file. Please try again.', '');
      }
    } finally {
      this.fulfillmentFileDownloading = false;
    }
  }

  /**
   * Recall contract - void the DocuSign envelope
   */
  async recallContract() {
    const tenantId = this.userService.loggedinUser?.tenantId;
    if (!tenantId) {
      this.toast.error('Tenant ID is required. Please login again.');
      return;
    }

    if (!this.id) {
      this.toast.error('Contract ID is missing.');
      return;
    }

    // Show recall dialog with void reason textarea
    const dialogRef = this.dialog.open(RecallDialogComponent, {
      width: '500px',
      data: {
        contractId: this.id
      }
    });

    dialogRef.afterClosed().subscribe(async (voidReason) => {
      // If voidReason is null, user cancelled the dialog
      if (voidReason) {
        this.isLoading = true;
        try {
          const response = await this.docuSignService.voidEnvelope(tenantId, this.id, voidReason).toPromise();

          if (response && response.isSuccess) {
            this.toast.success('Contract recalled successfully.');
            
            // Refresh contract to get updated status
            await this.getContract();
            this.cdr.detectChanges();
          } else {
            const errorMsg = response?.message || 'Failed to recall contract';
            this.toast.error(errorMsg);
          }
        } catch (error: any) {
          console.error('Error voiding envelope:', error);
          const errorMsg = error?.error?.message || error?.message || 'Failed to recall contract. Please try again.';
          this.toast.error(errorMsg);
        } finally {
          this.isLoading = false;
        }
      }
    });
  }
}
